<section class="container-fluid min-height-container bg-gray-300">
  <div class="container">
    <div class="row d-flex flex-column justify-content-center align-items-middle min-height-container">
      <div class="col-md-10 offset-md-1">
        <div class="row d-flex flex-fill">
          <article class="col-12 col-lg-6 d-flex flex-column align-items-middle justify-content-center order-2 order-lg-1">
            <h1 class="fw-bold display-5 mb-3">Offer Discounts Without Breaking the Rules</h1>
            <p class="fs-5 mb-2">Affordable Care. Fully Compliant. Zero Headaches.</p>
            <p class="fs-5">
              Helping your patients save shouldn’t put your practice at risk. Family Health Advantage makes it easy to offer
              legitimate, compliant discounts—so you stay protected while your patients get the care they need.
            </p>
            <ul class="fs-6 mb-0">
              <li>No legal risks</li>
              <li>No insurance violations</li>
              <li>No provider fees</li>
            </ul>
          </article>

          <article class="col-12 col-lg-6 d-flex flex-column align-items-middle justify-content-center order-1 order-lg-2 mb-4 mb-lg-0">
            <div class="intro-video ratio ratio-16x9">
              <iframe
                src="https://player.vimeo.com/video/1217668213?h=e71af3a0e0"
                title="Family Health Advantage for providers"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen>
              </iframe>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</section>
